export default [{
  path: 'systemServiceReportManage',
  name: 'systemServiceReportManage',
  component: function component() {
    return import('@/views/systemServiceReportManage/index');
  }
}];